export const systemAdminRole = 'systemAdminRole';
export const adminRole = 'adminRole';
export const teacherRole = 'teacherRole';
export const studentRole = 'studentRole';
export const whanauRole = 'whanauRole';
export const undefinedRole = 'undefinedRole';
